export const NUMBER_OF_STEPS = 3
